import GraphQLSDK from "../GraphQLSDK";
import CurrentPlayer from "../Player/CurrentPlayer";

async function checkScore(currentPlayer: CurrentPlayer): Promise<void> {
    const score = await GraphQLSDK.getScore();
    const playerData = await GraphQLSDK.getPlayer({
        id: currentPlayer.id,
    });

    const scoreElement = window.document.getElementById("score");

    if (scoreElement) {
        scoreElement.innerHTML = `Team: ${playerData.onlineObjects[0].team}<br/>Red: ${score.score.red} Blue: ${score.score.blue}`;
    }
}

export function initScore(currentPlayer: CurrentPlayer): void {
    setInterval(() => checkScore(currentPlayer), 1000);
}
